var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-checkout-step-shipping-contacts-messenger"},[_c('ui-form',{attrs:{"model":_vm.fields,"submit-handler":_vm.submitHandler},on:{"update":_vm.updateFormData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }